export default __webpack_public_path__ + "static/5-6d4da75ce800e83bbb287d2ff51709cc.png";